export default "__VITE_PUBLIC_ASSET__012dce33__"